import { collection, onSnapshot, query, where } from "firebase/firestore";
import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { firestoreDb } from "../Components/firebase";

const AllPresenceContext = createContext(new Map());

export const useAllUserPresence = () => useContext(AllPresenceContext);

export const AllUsersPresenceProvider = ({ children }) => {
  const [allPresence, setAllPresence] = useState(new Map());
  const presenceRef = useRef(new Map());

  useEffect(() => {
    const q = query(
      collection(firestoreDb, "bosUserPresenceStatus"),
      where("presence.state", "==", "online")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const newPresence = new Map();

      snapshot.docs.forEach((doc) => {
        const data = doc.data();
        newPresence.set(data.userGrapheneId, data.presence);
      });

      // Compare with ref instead of stale React state
      const prev = presenceRef.current;

      const isDifferent =
        newPresence.size !== prev.size ||
        Array.from(newPresence.keys()).some((key) => !prev.has(key));

      if (isDifferent) {
        presenceRef.current = newPresence; // update the ref
        setAllPresence(newPresence);       // update React state
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <AllPresenceContext.Provider value={allPresence}>
      {children}
    </AllPresenceContext.Provider>
  );
};
